import { queryOptions, useQuery } from '@tanstack/react-query'
import {
  type RegionIdAndUniversalId,
  type UniversalProductQueryParams,
  type UPAddressPayload,
} from '@/features/shop/services/UniversalProduct/types'
import { fetchUniversalProduct } from '@/features/shop/services/UniversalProduct/fetchers'

export const UniversalProductQuery = 'Universal Product Query'
export type UniversalProductQueryKey = readonly [
  typeof UniversalProductQuery,
  RegionIdAndUniversalId & {
    address: UPAddressPayload
    refetchDisabled?: boolean
  },
]
export const universalProductQueryOptions = (params: UniversalProductQueryParams) => {
  const { addresses, addressZip, ...restParams } = params
  const matchedAddress = addresses.find((a) => a.zip_code === addressZip)
  const address: UPAddressPayload = matchedAddress
    ? {
        street: matchedAddress.street1,
        city: matchedAddress.city,
        state: matchedAddress.state,
        zip: matchedAddress.zip_code,
      }
    : { zip: addressZip }
  return queryOptions({
    queryKey: [UniversalProductQuery, { ...restParams, address }] as const,
    queryFn: fetchUniversalProduct,
  })
}

export const useQueryUniversalProduct = ({
  params,
  enabled = true,
  keepPreviousData = true,
}: {
  params: UniversalProductQueryParams
  enabled?: boolean
  keepPreviousData?: boolean
}) => {
  return useQuery({
    ...universalProductQueryOptions(params),
    enabled,
    retryOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData ? (prevData) => prevData : undefined,
  })
}
